<template>
  <div>
    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step color="amber" :complete="e1 > 1" :step="1" @click="e1 = 1">Ingredients</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step color="amber" :complete="e1 > 2" :step="2" @click="e1 = 2">Sentence</v-stepper-step>
        <v-divider></v-divider>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content :step="1">
          <v-row>
            <v-col cols="6" class="mb-4">
              <h2 v-text="$t('exercise_proposition.step1.title')"></h2>
            </v-col>
            <v-col cols="6" class="mb-4">
              <p v-for="(item, index) in $t(
                'exercise_proposition.step1.description'
              )" :key="index" v-text="item" />
            </v-col>
          </v-row>
          <v-row v-if="doc">
            <v-col cols="6">
              <proposition-items v-model="doc.audience" title="Audiences" color="blue"
                subtitle="Who are you talking to?" @update="update" />
            </v-col>
            <v-col cols="6">
              <proposition-items v-model="doc.features" title="Features (technical)" subtitle="What are they here for?"
                color="green" @update="update" />
            </v-col>
            <v-col cols="6">
              <proposition-items v-model="doc.benefits" title="Benefits (emotional)"
                subtitle="How do we make them feel?" color="deep-orange" @update="update" />
            </v-col>
            <v-col cols="6">
              <proposition-items v-model="doc.reasons" title="Evidence" subtitle="Our proof points / what we offer them"
                color="pink" @update="update" />
            </v-col>
          </v-row>

          <bottom-navigation :save="true" :next="true" :prev="false" :gridView="false" :gridToggle="false"
            @save="saveExercise(true)" @prev="prevStep" @next="nextStep">
          </bottom-navigation>
        </v-stepper-content>
      </v-stepper-items>

      <v-stepper-items>
        <v-stepper-content :step="2">
          <v-row>
            <v-col cols="4" class="mb-4">
              <h2 v-text="$t('exercise_proposition.step2.title')"></h2>
            </v-col>
            <v-col cols="8" class="mb-4">
              <p v-for="(item, index) in $t(
                'exercise_proposition.step2.description'
              )" :key="index" v-text="item" />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="3">
              <proposition-side :doc="doc" />
            </v-col>

            <v-col cols="8" offset="1">
              <proposition-row v-model="doc.textAudience" label="For" tag="Audience" color="blue" />
              <proposition-row v-model="doc.textCompany" label="" tag="Organisation" color="green" />
              <proposition-row v-model="doc.textFeatures" label="Is" tag="Features" color="green" />
              <proposition-row v-model="doc.textBenefits" label="That" tag="Benefits" color="deep-orange" />
              <proposition-row v-model="doc.textEvidence" label="Because" tag="Evidence" color="pink" />
            </v-col>
          </v-row>

          <bottom-navigation :save="true" :next="false" :prev="true" :gridView="false" :gridToggle="false"
            @save="saveExercise(true)" @prev="prevStep" @next="nextStep">
          </bottom-navigation>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title class="headline">{{
          $t("exercise_service.saved.title")
          }}</v-card-title>

        <v-card-text>{{
          $t("exercise_service.saved.description")
          }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>

          <v-btn color="amber accent-1" text :to="`/users/project/${this.$route.params.id}`">
            Back to Project
          </v-btn>
          <v-btn color="amber accent-1" text to="/users/dashboard">
            Back to Dashboard
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import {
  PropositionRow,
  PropositionSide,
  PropositionItems,
} from "./proposition";

// import draggable from "vuedraggable";

const fb = require("@/firebaseConfig.js");
export default {
  name: "UserProposition",
  data() {
    return {
      collection: fb.propositionExCollection,
      returnRoute: "UserProposition",
      e1: 1,
      dialog: false,
      dialogMode: "",
      exercise: null,
      doc: {
        audience: [],
        features: [],
        benefits: [],
        reasons: [],
        // experience: [],
        textAudience: "",
        textFeatures: "",
        textBenefits: "",
        textEvidence: "",
        textCompany: "",
      },
      // inputs: [
      //   {
      //     title: "Audience",
      //     subtitle: "Who is it for?",
      //     color: "blue",
      //     model: this.audience
      //   },
      //   {
      //     title: "Features",
      //     subtitle: "What are you offering?",
      //     color: "green",
      //     model: this.features
      //   },
      //   {
      //     title: "Benefits",
      //     subtitle: "What are they buying?",
      //     color: "deep-orange",
      //     model: this.benefits
      //   },
      //   {
      //     title: "Evidence",
      //     subtitle: "Reasons to believe",
      //     color: "pink",
      //     model: this.reasons
      //   },
      // ],
      debug: false,
      intervalId: null,
      unsubscribe: null,
    };
  },
  components: {
    BottomNavigation,
    PropositionRow,
    PropositionSide,
    PropositionItems,
    // draggable
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  beforeRouteUpdate(to, from, next) {
    this.init();
    next();
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    if (this.unsubscribe) this.unsubscribe();
    if (this.intervalId) clearInterval(this.intervalId);
  },
  methods: {
    init() {
      let vm = this;
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.intervalId = setInterval(function () {
        vm.checkStatus();
      }, 300);
    },
    update() {
      this.saveExercise(false);
    },
    checkStatus() {
      if (this.currentProjectModel && this.currentProjectModel.id) {
        clearInterval(this.intervalId);
        this.doc.textCompany = this.currentProject;
        this.getExercise();
      }
    },
    nextStep() {
      this.e1++;
    },
    prevStep() {
      this.e1--;
    },
    getExercise() {
      console.log("get exercise");
      if (this.unsubscribe) {
        this.unsubscribe();
        this.unsubscribe = null;
      }
      let ref = this.collection
        .where("pid", "==", `${this.currentProjectModel.id}`)
        .where("uid", "==", this.currentUser.uid);
      this.unsubscribe = ref.onSnapshot((querySnapshot) => {
        let items = [];
        querySnapshot.forEach((docs) => {
          let doc = docs.data();
          items.push(doc);
        });
        this.exercise = items[0];
        if (this.exercise && this.exercise.doc) {
          this.doc = { ...this.doc, ...this.exercise.doc };
        }
      });
    },
    cleanDoc() {
      const defaults = {
        audience: [],
        features: [],
        benefits: [],
        reasons: [],
        textAudience: "",
        textFeatures: "",
        textBenefits: "",
        textEvidence: "",
        textCompany: "",
      };
      const cleaned = {};
      Object.keys(defaults).forEach((key) => {
        const val = this.doc[key];
        cleaned[key] =
          val === undefined || val === null ? defaults[key] : val;
      });
      return cleaned;
    },
    saveExercise(notify) {
      // check if exercise exists
      let ref;
      let vm = this;
      if (this.exercise == null) {
        ref = this.collection.doc();
      } else {
        ref = this.collection.doc(this.exercise.id);
      }
      ref
        .set({
          updatedOn: new Date(),
          id: ref.id,
          uid: this.currentUser.uid,
          pid: this.currentProjectModel.id,
          doc: this.cleanDoc(),
        })
        .then(() => {
          console.log("saved");
          if (notify) {
            vm.dialog = true;
          }
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },
    closeDialog() {
      this.dialog = false;
      this.dialogMode = "";
    },
  },
};
</script>
